import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

// Lazy load components
const StockReturnList = lazy(() => import('../Pages/StockReturnList'));
const AddStockReturn = lazy(() => import('../Pages/AddStockReturn'));
const EditStockReturn = lazy(() => import('../Pages/EditStockReturn'));
const StockReturnView = lazy(() => import('../Pages/StockReturnView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';

LoadingOverlay.propTypes = undefined;

function StockReturnRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/stock/return"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <StockReturnList history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/stock/return/list"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <StockReturnList history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/stock/return/add"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <AddStockReturn history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/stock/return/edit/:slack"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <EditStockReturn history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/stock/return/view/:slack"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <StockReturnView history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
        </Switch>
    );
};

export default StockReturnRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
